// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const vnr: CountryValidator<"AT"> = createValidator(
  "at.vnr",
  11,
);

export default vnr;
export const compact = vnr.compact;
export const format = vnr.format;
export const validate = vnr.validate;
export const generate = (): string =>
  vnr.generate?.() ??
  (() => {
    throw new Error(
      "Validator at.vnr cannot generate values",
    );
  })();
